import React, { useMemo } from 'react';
import getSmoothCurvePath from '../../Helpers/periodontalLines/getSmoothCurvePath';

export interface PeriodontalLinePoint {
	x: number;
	y: number;
}

interface Props {
	points: PeriodontalLinePoint[];
	width: string;
	color: string;
}

const DENTToothPeriodontalLineSingle = ({ points, width, color }: Props) => {
	const pathData = useMemo(() => {
		if (points.length === 0) return '';

		let path = `M ${points[0].x},${points[0].y}`;

		for (let i = 1; i < points.length; i++) {
			const prev = points[i - 1];
			const curr = points[i];

			path += getSmoothCurvePath({
				prevX: prev.x,
				prevY: prev.y,
				currX: curr.x,
				currY: curr.y,
			});
		}

		return path;
	}, [points]);

	return <path d={pathData} stroke={color} strokeWidth={width} fill='none' />;
};

export default DENTToothPeriodontalLineSingle;
